import { render, staticRenderFns } from "./UpdateOrderDialog.vue?vue&type=template&id=77ff8729"
import script from "@/views/Orders/UpdateOrderDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Orders/UpdateOrderDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Orders/update-order-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports